import { useProfile } from 'src/features/common/profile/hooks/profile.hooks';

export const useTechContemporary = () => {
    const profile = useProfile();
    const isOwnerTechContemporary = profile?.user?.id === process.env.NEXT_PUBLIC_TECH_CONTEMPORARY_OWNER_ID;

    return { isOwnerTechContemporary };
};